<template>
  <div id="hrms13x-detail-tab5" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab5">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STDEMPC5']['10'] }}
      </h3>
    </div>
    <div id="tab5" class="panel-collapse collapse tab-detail">
      <div class="">

        <div class="col-xs-12 col-md-4 pull-left">  
          <div class="col-xs-12  card-ui clearfix">
            <div class="sub-topic-box clearfix">
              <div class="sub-topic">{{ labels['STDEMPC5']['20'] }}</div>
            </div>
            <div class="data-box clearfix">
              <div class="table-row clear-padding clearfix" v-for="table1Row in data.table1.rows">
                <div class="col-xs-12 body-table-left color-skin">
                  <!-- <template v-if="$router.match(table1Row.codapp.toLowerCase()).name !== '404'"> -->
                  <!-- </template> -->
                  <a :href="genUrl(table1Row.codapp)" target="_blank">
                    <i class="fa fa-circle"></i> 
                    <span>{{ table1Row.detail }}</span>
                  </a>
                  <!-- <router-link :to="{ name: table1Row.codapp.toLowerCase(), query: {codempidq: indexSelected.codempid} }">
                    <i class="fa fa-circle"></i> 
                    <span>{{ table1Row.detail }}</span>
                  </router-link> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 pull-left">  
          <div class="col-xs-12  card-ui clearfix">
            <div class="sub-topic-box clearfix">
              <div class="sub-topic">{{ labels['STDEMPC5']['30'] }}</div>
            </div>
            <div class="data-box clearfix">
              <div class="table-row clear-padding clearfix" v-for="table2Row in data.table2.rows">
                <div class="col-xs-12 body-table-left color-skin">
                  <!-- <template v-if="$router.match(table2Row.codapp.toLowerCase()).name !== '404'"> -->
                  <!-- </template> -->
                  <a :href="genUrl(table2Row.codapp)" target="_blank">
                    <i class="fa fa-circle"></i> 
                    <span>{{ table2Row.detail }}</span>
                  </a>
                  <!-- <router-link :to="{ name: table2Row.codapp.toLowerCase(), query: {codempidq: indexSelected.codempid} }">
                    <i class="fa fa-circle"></i> 
                    <span>{{ table2Row.detail }}</span>
                  </router-link> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 pull-right">  
          <div class="col-xs-12  card-ui clearfix">
            <div class="sub-topic-box clearfix">
              <div class="sub-topic">{{ labels['STDEMPC5']['40'] }}</div>
            </div>
            <div class="data-box clearfix">
              <div class="table-row clear-padding clearfix" v-for="table3Row in data.table3.rows">
                <div class="col-xs-12 body-table-left color-skin">
                  <!-- <template v-if="$router.match(table3Row.codapp.toLowerCase()).name !== '404'"> -->
                  <!-- </template> -->
                  <a :href="genUrl(table3Row.codapp)" target="_blank">
                    <i class="fa fa-circle"></i> 
                    <span>{{ table3Row.detail }}</span>
                  </a>
                  <!-- <router-link :to="{ name: table3Row.codapp.toLowerCase(), query: {codempidq: indexSelected.codempid} }">
                    <i class="fa fa-circle"></i> 
                    <span>{{ table3Row.detail }}</span>
                  </router-link> -->
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import env from 'src/../env.js'

export default {
  name: 'hrms13x-detail-tab5',
  props: [ 'labels', 'data', 'indexSelected', 'nowLang' ],
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL')
    }
  },
  methods: {
    genUrl (codapp) {
      codapp = codapp.toLowerCase()
      let lang = ''
      if (codapp !== 'hresh1x') {
        lang = this.nowLang + '/'
      }
      return this.baseURL + lang + codapp + '?codempidq=' + this.indexSelected.codempid
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab5.vue?4c17f45c